<template>
  <div class="MessCent">
    <div class="MessCent-background">
      <div class="NewCape-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        消息中心
      </div>
      <div class="MessCent-fill"></div>
      <div v-if="this.messhelp == '0'">
        <div class="MessCent-content">
          <router-link :to="{path: 'InfoDeta',query: {metitle: '什么是欧堡利亚一卡通',mecont: '一卡通是欧堡利亚统一的会员账号,可以在欧堡利亚旗下的酒店、餐饮、会所、等产业以及合作商家消费使用,且享受超值消费折扣,过程中产生的积分可以冲抵消费。',metime: '2019-04-10 14:59:36'}}">
            <div class="MessCent-content-title">
              <p class="MessCent-content-title-text">什么是欧堡利亚一卡通</p>
              <p class="MessCent-content-title-cent">一卡通是欧堡利亚统一的会员账号,可以在欧堡利亚旗下的酒店、餐饮、会所、等产业以及合作商家消费使用,且享受超值消费折扣,过程中产生的积分可以冲抵消费。</p>
              <p class="MessCent-content-title-time">2019-04-10 14:59:36</p>
            </div>
          </router-link>
        </div>
      </div>
      <div v-else>
        <div class="MessCent-content" v-for="ermessinta in messinta" :key="ermessinta.ID">
          <router-link :to="{path: 'InfoDeta',query: {metitle: ermessinta.NAME,mecont: ermessinta.CONTENT,metime: ermessinta.UPDATE_DATE}}">
            <div class="MessCent-content-title">
              <p class="MessCent-content-title-text">{{ermessinta.NAME}}</p>
              <p class="MessCent-content-title-cent" v-html="ermessinta.CONTENT"></p>
              <p class="MessCent-content-title-time">{{ermessinta.UPDATE_DATE}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + messfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{messtips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + messlong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      messfail: 'none',
      messtips: '',
      messinta: '',
      messhelp: '',
      messlong: 'block'
    }
  },
  created () {
    // 接收帮助中心传过来的参数
    this.messhelp = this.$route.query.servhelp;
    this.$axios.post('app/sysMessage',this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.messlong = 'none';
      if(res.status == '200'){
        this.messinta = res.data.message;
      }else{
        this.messtips = '状态码错误';
        this.messfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.messfail = 'none';
        },1200)
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/MessCent.css";
</style>